<app-feature-tiles-grid data-at-dry-contact-panel>
  <app-features-container
    [overlayType]="FeaturesDetailsOverlayTypeEnum.DryContact"
    [header]="'+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.HEADER' | translate"
  >
    <div header class="flex flex-col flex-row gap-[4px]">
      <app-pill *ngIf="isProductionLimitation" [type]="PillType.primary">
        {{ '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.PRODUCTION_LIMITATION' | translate }}
      </app-pill>
      <app-pill *ngIf="isConsumptionLimitation" [type]="PillType.primary">
        {{ '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.CONSUMPTION_LIMITATION' | translate }}
      </app-pill>
    </div>

    <!-- heating.device.smartGrid -->
    <app-feature-tile
      data-at-heating-device-smart-grid
      *ngIf="smartGrid$ | async | ready as feature"
      isFullWidth="true"
      feature
      [label]="'+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.SG_DESCRIPTION' | translate"
      [value]="feature | value2: FeaturePropertyKey.requestedState | dryContactSmartGrid"
      [attr.data-feature]="feature.feature"
      [informationTooltip]="
        feature | value2: FeaturePropertyKey.requestedState | dryContactSgReadyInfo
      "
      [showInformationTooltip]="true"
    ></app-feature-tile>

    <!-- dryContact.power.instantaneousPower -->
    <app-feature-tile
      data-at-drycontact-power-instantaneous-power
      *ngIf="dryContactPowerConsumption$ | async | ready as feature"
      isFullWidth="true"
      feature
      [label]="
        dryContactConsumptionStatus$
          | async
          | ready
          | value2: FeaturePropertyKey.value
          | dryContactConsumptionStatus
      "
      value="{{ feature | value2: FeaturePropertyKey.value }} {{
        feature | unit: FeaturePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [informationTooltip]="
        '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.CONSUMPTION_STATUS_TOOLTIP' | translate
      "
      [showInformationTooltip]="true"
    ></app-feature-tile>
  </app-features-container>
</app-feature-tiles-grid>
